import { AssetType } from "@domains/aggregates/interfaces/Reports/iPNLReport";
export const THdefaultPageSize = 10;
export const ITRANSACTIONHISTORYSHORTCODES = [
    {
        display: "Listed Equity",
        value: AssetType.EQ,
    },
    {
        display: "Unlisted Equity",
        value: AssetType.UnlistedEquity,
    },
    {
        display: "Fixed Income",
        value: AssetType.FixedIncome,
    },
    {
        display: "Certificate Of Deposit",
        value: AssetType.CertOfDeposit,
    },
    {
        display: "Commercial Paper",
        value: AssetType.CommPaper,
    },
    {
        display: "Non Convertible Debenture",
        value: AssetType.NCD,
    },
    {
        display: "Warrant",
        value: AssetType.Warrant,
    },
    {
        display: "Bonds",
        value: AssetType.Bonds,
    },
    {
        display: "Debentures",
        value: AssetType.Debentures,
    },
    {
        display: "Indian Depository Receipt",
        value: AssetType.IndianDepoReceipt,
    },
    {
        display: "Preference Share",
        value: AssetType.PreferenceShare,
    },
    {
        display: "Corp FD",
        value: AssetType.CorpFD,
    },
    {
        display: "RBI Bonds ",
        value: AssetType.RBIBonds,
    },
    {
        display: "54 EC",
        value: AssetType.EC54,
    },
    {
        display: "Derivatives",
        value: AssetType.Derivatives,
    },
    {
        display: "Derivative Equity",
        value: AssetType.DEquity,
    },
    {
        display: "Currency",
        value: AssetType.DCurrency,
    },
    {
        display: "Commodity",
        value: AssetType.DCommodity,
    },
    {
        display: "PMS",
        value: AssetType.PMS,
    },
    {
        display: "Mutual Fund",
        value: AssetType.MutualFund,
    },
    {
        display: "Exchange Traded Funds",
        value: AssetType.ETF,
    },
    {
        display: "INVITS",
        value: AssetType.INVITS,
    },
    {
        display: "AIF",
        value: AssetType.AIF,
    },
    {
        display: "Structured Products",
        value: AssetType.StructuredProducts,
    },
    {
        display: "Managed Portfolios",
        value: AssetType.MP,
    },
    {
        display: "Real Estate",
        value: AssetType.RealEstate,
    },
    {
        display: "Commodities",
        value: AssetType.Commodity,
    },
];
